function ynSiengeFlag(v) {
  return v === 'S' ? 'Sim' : 'Não';
}

function creditorPaymentIconTone(iso) {
  if (!iso) return 'none';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'none';
  const ageDays = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (ageDays <= 31) return 'fresh';
  if (ageDays <= 90) return 'aging';
  return 'stale';
}

function creditorPaymentIconTitle(iso) {
  if (!iso) return 'Pagamentos submetidos — sem pagamento sincronizado na base Sienge Pay.';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'Pagamentos submetidos';
  const ageDays = Math.floor((Date.now() - d.getTime()) / 86400000);
  const when = d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  if (ageDays <= 31) return `Pagamentos submetidos — último sincronizado em ${when} (<=31 dias).`;
  if (ageDays <= 90) return `Pagamentos submetidos — último sincronizado em ${when} (32-90 dias).`;
  return `Pagamentos submetidos — último sincronizado em ${when} (>90 dias).`;
}

function siengeBankDataIsEmpty(data) {
  if (!data || typeof data !== 'object') return false;
  const rawCount = data.resultSetMetadata?.count;
  let count = rawCount;
  if (typeof rawCount === 'string' && /^\d+$/.test(rawCount.trim())) {
    count = parseInt(rawCount.trim(), 10);
  }
  const results = data.results;
  const len = Array.isArray(results) ? results.length : 0;
  if (len > 0) return false;
  if (count === 0) return true;
  if (count === undefined || count === null) return true;
  return false;
}

function fmtLastPaymentDate(d) {
  if (d === null || d === undefined || d === '') return '-';
  const x = new Date(d);
  if (Number.isNaN(x.getTime())) return '-';
  return x.toLocaleDateString('pt-BR');
}

function fmtLastPaymentAmount(n) {
  if (n === null || n === undefined || n === '') return '-';
  const num = Number(n);
  if (Number.isNaN(num)) return '-';
  return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function fmtCreated(d) {
  if (!d) return '—';
  const x = new Date(d);
  if (Number.isNaN(x.getTime())) return '—';
  return x.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function fmtCity(r) {
  const a = r?.address;
  const city = String(r?.address_city_name || (a && typeof a === 'object' ? a.cityName : '') || '').trim();
  const uf = String(r?.address_state || (a && typeof a === 'object' ? a.state : '') || '').trim();
  if (city && uf) return `${city}-${uf}`;
  if (city) return city;
  return '—';
}

function fmtSiengeDetailSync(iso) {
  if (!iso) return '— Ainda sem sincronização gravada nesta base; use «Sincronização Total».';
  const x = new Date(iso);
  if (Number.isNaN(x.getTime())) return '—';
  return x.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

function fmtSyncElapsed(sec) {
  const s = Math.max(0, Math.floor(Number(sec) || 0));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
}

export {
  creditorPaymentIconTitle,
  creditorPaymentIconTone,
  fmtCity,
  fmtCreated,
  fmtLastPaymentAmount,
  fmtLastPaymentDate,
  fmtSiengeDetailSync,
  fmtSyncElapsed,
  siengeBankDataIsEmpty,
  ynSiengeFlag,
};
